import { useAuth } from "./auth";
import { LoginPage} from "./pages/LoginPage";

export function AuthGate({ children }: { children: React.ReactNode }) {
  const { initializing, accessToken } = useAuth();

  if (initializing) return <div>Loading…</div>;     // optional splash
  if (!accessToken) return <LoginPage />;               // show your login page/component
  return <>{children}</>;
}